import React from 'react';
import { useTranslate } from 'react-admin';

import { FilterToggleButtonGroup, StyledToggleButton } from 'components/filters/FilterToggleInput';

export const operationModeToggleEnum = [
	{
		value: "scanner",
		name: "osfc.filters.state.scanner",
	},
	{
		value: "manual",
		name: "osfc.filters.state.manual",
	},
];

export const scanToCreateModeOption = {
	value: "scan_to_create_pallet",
	name: "tab.pallets.scan_to_create",
};

// Operation modes that drive the scanner UI (store-existing and scan-to-create).
export const isScannerOperationMode = (operationMode) =>
	operationMode === operationModeToggleEnum[0].value ||
	operationMode === scanToCreateModeOption.value;

export const OperationModeToggleFilter = ({
	operationMode: value,
	setOperationMode: onChange,
	disabled,
	onlyScanner = false,
	canScanToCreatePallet = false,
}) => {
	const translate = useTranslate();
	const baseOptions = onlyScanner
		? operationModeToggleEnum.filter((state) => state.value === "scanner")
		: operationModeToggleEnum;
	const options = canScanToCreatePallet ? [...baseOptions, scanToCreateModeOption] : baseOptions;

	const handleChange = (e, newValue) => {
		if (newValue != null) {
			onChange(newValue);
		} else if (onlyScanner) {
			// Allow deselect when only one scanner option is rendered
			onChange(null);
		}
	};

	return (
		<FilterToggleButtonGroup value={value} onChange={handleChange} exclusive>
			{options.map((state, index) => 
				<StyledToggleButton 
					value={state.value} 
					key={index} 
					disabled={typeof disabled === "function" ? disabled(state) : disabled}
				>
					{translate(state.name)}
				</StyledToggleButton>
			)}
		</FilterToggleButtonGroup>
	);
};
